var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 12H24V8H22V12H17V8H15V12H10V8H8V12H4V7.162L5.721 2H26.279L28 7.162V12ZM26 22H14V14H26V22ZM29.948 6.684L27.948 0.684C27.812 0.275 27.431 0 27 0H5C4.569 0 4.188 0.275 4.051 0.684L2.051 6.684C2.017 6.786 2 6.893 2 7V13C2 13.553 2.448 14 3 14H4V24H6V14H12V24H28V14H29C29.553 14 30 13.553 30 13V7C30 6.893 29.982 6.786 29.948 6.684Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.846bd5c8282d2b3aeeb2d709f6b7477c.svg";
export { ForwardRef as ReactComponent };